import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setSwBookState} from "../../../../store/reducers/search-widget";
import {Box, Grid, Typography} from '@material-ui/core';
import {t} from 'ttag';
import Container from "@material-ui/core/Container";
import {
    AzoButton,
    BookContentHeaderConnected,
    BookContentFlowConnected,
    CrossSellingConnected,
    FullscreenDialog,
    LoginFormConnected,
    RouteSelectorConnected,
    TabContent
} from '../../../index';

const BookContentConnected = () => {

    const fullscreen = useSelector(state => state.sw.book.fullscreen);
    const backgroundImage = useSelector(state => state.sw.book.backgroundImage);
    const origin = useSelector(state => state.sw.book.origin);
    const destination = useSelector(state => state.sw.book.destination);
    const dispatch = useDispatch();

    if (!fullscreen) {
        return (
            <TabContent>
                <Box mb={2}>
                    <CrossSellingConnected />
                </Box>
                <Box mb={2}>
                    <RouteSelectorConnected/>
                </Box>
                <AzoButton
                    variant={'contained'}
                    color={'secondary'}
                    size={'large'}
                    onClick={() => dispatch(setSwBookState({fullscreen: true}))}
                    disabled={Boolean(!origin && !destination)}
                    disableElevation
                    fullWidth
                    tall>
                    <Typography variant={'h6'}>{t`Next`}</Typography>
                </AzoButton>
            </TabContent>
        );
    }

    return (
        <FullscreenDialog
            className={'search-widget-v4-portal'}
            PaperProps={{style: {backgroundColor: 'rgba(0, 40, 87, .3)'}}}
            style={{
                backgroundColor: '#002857',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                ...(backgroundImage ? {backgroundImage: `url('${backgroundImage}')`} : {})
            }}
        >
            <LoginFormConnected />
            <Box p={{xs: 1, sm: 2, md: 5}}>
                <Container maxWidth={'xl'}>
                    <Grid container spacing={3}>
                        <BookContentHeaderConnected/>
                    </Grid>
                    <Box mt={{xs: 3, sm: 3, md: 5}} color={'common.white'}>
                        <BookContentFlowConnected/>
                    </Box>
                </Container>
            </Box>
        </FullscreenDialog>
    );
};

export default BookContentConnected;